import axios from "axios";

export const state = {
    transactions: [],
};

export const getters = {
    transactions: state => state.transactions,
};

export const mutations = {
    setTransactions(state, newValue) {
        state.transactions = newValue
    },
};

export const actions = {
    async fetchTransactions({ commit }) {
        await axios.get('/transactions').then(res => {
            commit('setTransactions', res.data.transactions)
        })
    },
    async filterTransactions({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filtertransactions";
        await axios.post(url, formData).then((response) => {
            commit('setTransactions', response.data.transactions)
        })
    },
};
